import styled from '@emotion/styled';

export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
`;
